import React, {FC, useEffect} from 'react';
import {useParams, Link} from 'react-router-dom';
import {useRecoilValue, useResetRecoilState} from 'recoil';

import {singleNews} from '../state/news/singleNews';
import {newsType} from '../types/news';

import useFetchSingleNews from '../hooks/news/useFetchSingleNews';

import UIPageContainer from '../components/UIWrappers/UIPageContainer';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';
import UICardComponent from '../components/UIWrappers/UICardComponent';
import UITag from '../components/UICommon/UITag';
import {parseHtml} from '../utils/parseHtml';

const NewsSinglePage: FC = () => {
  const {slug} = useParams();
  const resetNews = useResetRecoilState(singleNews);
  const {
    isLoading,
    isError,
    refetch,
  } = useFetchSingleNews(slug ?? '');
  const newsData: newsType | undefined = useRecoilValue(singleNews);

  useEffect(() => {
    resetNews();
    if (slug != undefined) {
      refetch();
    }
  }, [slug]);

  if (isLoading || newsData == null) {
    return <UILoadingIndicator />;
  }

  if (isError) {
    return (
      <UIErrorIndicator message='Ett fel uppstod, om felet är återkommande vänligen kontakta oss på canita@mih.nu'/>
    );
  }

  const parsedByline = parseHtml(newsData.byline);

  return (
    <UIPageContainer>
      <div className='py-12'>
        <div className='mb-6'>
          <Link to='/all-inclusive/' className='text-pink-primary underline font-medium'>
            Tillbaka till All Inclusive
          </Link>
        </div>
        <UICardComponent width='w-full' padding='pl-8 pr-5 pt-6 pb-10' extraStyles='relative'>
          <div className='flex flex-col lg:flex-row gap-x-16 gap-y-8'>
            <div className='w-full lg:w-3/5 flex flex-col'>
              <UITag name={newsData.tags} extraStyles='w-fit'/>
              <h1 className='mt-6 text-32px font-semibold pb-5 text-black-dark'>
                {newsData.title}
              </h1>
              <div className='text-black-dark text-lg font-normal pb-7'>
                {parsedByline}
              </div>
              <div
                className='font-normal text-base text-black-dark/70 leading-relaxed content'
                dangerouslySetInnerHTML={{__html: newsData.description}}
              />
            </div>
            <div className='w-full lg:w-2/5 h-auto'>
              <img
                className='w-full h-full object-cover rounded-15px'
                src={newsData.image}
                alt={newsData.title}
              />
            </div>
          </div>
        </UICardComponent>
      </div>
    </UIPageContainer>
  );
};

export default NewsSinglePage;
